import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addReview({ commit }, item) {
    return this.$axios.$post('admin/reviews/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeReview({ commit }, item) {
    return this.$axios.$delete(`admin/reviews/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateReview({ commit }, item) {
    return this.$axios.$put(`admin/reviews/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchReview({ commit }, id) {
    return this.$axios.$get(`admin/reviews/${id}`).then((response) => {
      return response.data
    })
  },
  fetchReviews({ commit }) {
    return this.$axios.$get('admin/reviews').then((response) => {
      commit('load', response.data)
    })
  },

  /**
   * Stream the reviews export file (XLSX or CSV) for the active filter window.
   * @param {Object} context - Vuex context
   * @param {Object} params - { start_date, end_date, score, format, ...listFilters }
   * @returns {Promise<Blob>} Export file blob
   */
  async exportReviews(_context, params = {}) {
    const response = await this.$axios.get('admin/export/reviews', {
      params,
      responseType: 'blob',
    })
    return response.data
  },
}
